import { render, staticRenderFns } from "./EditorComponentRow.vue?vue&type=template&id=70b4c1a0&"
import script from "./EditorComponentRow.vue?vue&type=script&lang=js&"
export * from "./EditorComponentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports